/* eslint-disable no-extra-boolean-cast */
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import { Component } from 'react';
import { Form } from 'react-bootstrap';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { change, Field, getFormValues, isDirty, reduxForm } from 'redux-form';
import { RuntimeContext } from '../../../../../../common/RuntimeContext';
import { getManyCompanies } from '../../../../../shared/actions';
import FormFeedback from '../../../../../shared/components/formComponents/FormFeedback';
import BasicSelect from '../../../../../shared/components/formComponents/groups/BasicSelect';
import VerbButton, { VERB_BUTTON_TYPE } from '../../../../../shared/components/VerbButton';

class CompanyLicensesForm extends Component {
    static propTypes = {
        changeContentValues: PropTypes.func,
        getManyCompanies: PropTypes.func,
        initialValues: PropTypes.object,
        handleSubmit: PropTypes.func.isRequired,
        submitSucceeded: PropTypes.bool,
        submitFailed: PropTypes.bool,
        onCancel: PropTypes.func,
        submitting: PropTypes.bool,
        error: PropTypes.string,
        currentValues: PropTypes.object,
        company: PropTypes.object,
        dirty: PropTypes.bool,
        toggleShowUnsavedChangesPrompt: PropTypes.func,
        companyList: PropTypes.array,
        companyLicenses: PropTypes.array,
        isVerbAdmin: PropTypes.bool,
        isInstructionalAdmin: PropTypes.bool
    };

    static contextType = RuntimeContext;

    constructor(props) {
        super(props);
        this.state = {
            isLoading: false
        };
    }

    componentDidMount() {
        this.setState({ isLoading: true });
        this.props
            .getManyCompanies({ pathsContext: this.context.pathsWeb })
            .then(() => this.setState({ isLoading: false }));
    }

    render() {
        const {
            submitting,
            handleSubmit,
            onCancel,
            error,
            companyList = [],
            isVerbAdmin,
            companyLicenses = []
        } = this.props;
        const { isLoading } = this.state;
        return (
            <>
                {isVerbAdmin ? (
                    <Form className={'companyForm container'}>
                        <Field
                            name={'companyLicenses'}
                            className={'row company-form-field'}
                            label={'Company Licenses'}
                            inputClassName={'col-12 col-sm-5 no-padding'}
                            component={BasicSelect}
                            placeholder={'None'}
                            description={`Link this company to other companies`}
                            companyForm={true}
                            options={companyList}
                            menuBuffer={15}
                            isMulti={true}
                            styleProps={{ horizontal: true }}
                        />
                        <br />
                        <div className={'col-12 formButtons'}>
                            <VerbButton
                                fontAwesomeIcon={'fa-save'}
                                textId={'BUTTON_SAVE'}
                                defaultMessage={'SAVE'}
                                onClick={(values) => {
                                    this.setState({ formSubmitted: true });
                                    handleSubmit(values);
                                }}
                                disabled={submitting}
                            />
                            <VerbButton
                                buttonType={VERB_BUTTON_TYPE.CANCEL}
                                fontAwesomeIcon={'fa-ban'}
                                textId={'BUTTON_CANCEL'}
                                defaultMessage={'CANCEL'}
                                onClick={onCancel}
                                disabled={submitting}
                            />
                        </div>
                        <FormFeedback failMsg={error} className={'col-12'} {...this.props} />
                    </Form>
                ) : (
                    <>
                        {!!companyLicenses.length ? (
                            <ul>
                                <h2 style={{ paddingBottom: 10 }}>Company Licenses:</h2>
                                {companyLicenses.map(({ label }) => (
                                    <li key={label} style={{ marginLeft: '6%' }}>
                                        {label}
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            !isLoading && <h2> No Company Licenses</h2>
                        )}
                    </>
                )}
            </>
        );
    }
}

export const CompanyLicensesFormComponent = CompanyLicensesForm;
export const makeMapStateToProps = () => {
    const mapStateToProps = (state, ownProps) => {
        const { companyLicenses = [], _id: userCompanyId } = ownProps.company;
        const { companies: { byId: companiesById = {}, sortedIds = [] } = {} } = state;
        const formattedCompanyLicenses = [];
        if (!isEmpty(companyLicenses) && !isEmpty(companiesById)) {
            companyLicenses.forEach((licenseId) => {
                if (companiesById[licenseId]?.name && companiesById[licenseId]?._id) {
                    formattedCompanyLicenses.push({
                        label: companiesById[licenseId].name,
                        value: companiesById[licenseId]._id
                    });
                }
            });
        }
        const currentValues = getFormValues('CompanyLicenses')(state);
        const companyList = [];

        sortedIds.forEach((id) => {
            if (id !== userCompanyId) {
                companyList.push({ label: companiesById[id].name, value: companiesById[id]._id });
            }
        });
        return {
            dirty: isDirty('CompanyLicenses'),
            initialValues: {
                companyLicenses: formattedCompanyLicenses
            },
            currentValues,
            companyLicenses: formattedCompanyLicenses,
            companyList: companyList.sort((a, b) => (a.label > b.label ? 1 : -1))
        };
    };

    return mapStateToProps;
};

const mapDispatchToProps = (dispatch) => ({
    changeContentValues: (params) => dispatch(change('CompanyContent', params.field, params.value)),
    getManyCompanies: (params) => dispatch(getManyCompanies(params))
});

const CompanyLicensesFormValidation = {
    form: 'CompanyLicenses',
    destroyOnUnmount: false,
    enableReinitialize: true
};

export default compose(
    connect(makeMapStateToProps, mapDispatchToProps),
    reduxForm(CompanyLicensesFormValidation)
)(CompanyLicensesForm);
